import { writable } from 'svelte/store'

export let THREE = writable(null)